import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { IPagination } from 'app/services/authentication/connection/interfaces/pagination';
import { CarrierUserPaginatedResponseDTO, ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class GetUsersListCommand extends IRequestCommand<GetUsersListResponse,
  ErrorDetails,
  GetUsersListCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  override setParameters(params: GetUsersListCommandParameters) {
    this.urlSections.push('carriers');
    this.urlSections.push('carrierUser');
    this.urlSections.push(`${params.carrierUserId}`);
    this.urlSections.push('paginated');

    this.paramsSections.push(`page=${params.page}`);
    this.paramsSections.push(`size=${params.size}`);
    this.paramsSections.push(`column=${params.column}`);
    this.paramsSections.push(`sort=${params.sort}`);
    this.composeUrl();
  }
}

export interface GetUsersListCommandParameters
  extends IPagination,
    ICommandParameters {
  carrierUserId: number;
}

export interface GetUsersListResponse
  extends CarrierUserPaginatedResponseDTO,
    ICommandResponse {
}
